import { HeartbreakIcon } from '@hugeicons/react'

import {
  LevelPlayInterstitial,
  LevelPlayInterstitialRestartAction
} from './LevelPlayInterstitial'

/**
 * Vidas esgotadas. Servida aos dois domínios — antes eram duas implementações
 * que divergiam em ícone (`text-red-500`/`text-4xl` × `text-danger`/`text-5xl`),
 * título (`text-2xl` × `text-3xl`) e corpo (`text-sm` × `text-base`), dizendo o
 * mesmo texto.
 */
export const LevelPlayOutOfHearts = ({ onRestart }: { onRestart: () => void }) => (
  <LevelPlayInterstitial
    icon={<HeartbreakIcon size={48} variant="duotone" className="text-danger" />}
    title="Sem vidas"
    description="É uma pena, mas suas vidas acabaram!"
    action={<LevelPlayInterstitialRestartAction onRestart={onRestart} />}
  />
)
